// extracted by mini-css-extract-plugin
module.exports = {"hr1":"App_hr1__2UytA"};